import { useState } from "react";
import EditableInput from "../../../../utils/EditableInput";
import ImageUpload from "../../../../utils/ImageUpload";
import WheelOfPrizesPrizeOptionsModal from './WheelOfPrizesPrizeOptionsModal';
import WheelOfPrizesPrizeAdvancedOptions from './WheelOfPrizesPrizeAdvancedOptions';

function hasOverlap(ranges) {
    const sorted = [...ranges].sort((a, b) => a.from - b.from);

    for (let i = 0; i < sorted.length - 1; i++) {
        const current = sorted[i];
        const next = sorted[i + 1];

        if (current.to > next.from) {
          return true;
      }
  }
  return false;
}

function WheelOfPrizesPrizeOptions({ prize, sliceIdx, update, deletePrize, currentCampaignId, _updateSubmit, advancedOnModal, locked }) {
    const [showAdvanced, setShowAdvanced] = useState(false);
    const extra = {sliceIdx: sliceIdx, prize_id: prize.id};
    let inconsistentQuotaCount = false;
    let overlappingQuotaWindows = false;
    if(prize.strategy?.strategy==="rolling-quota"){
        const qCount = prize.strategy.windows.reduce((acc, {quantity})=>acc+quantity, 0);
        inconsistentQuotaCount = qCount != prize.stock;
        overlappingQuotaWindows = hasOverlap(prize.strategy.windows);
    }
    const compStock = () => {
        return prize.stock ? prize.stock : <span className="font--16">∞</span>
    }
    const autosave = async (key, value, extra) => {
        await update(key, value, extra)
        _updateSubmit();
    }
    const done = () => {
        setShowAdvanced(false);
    }
	return (
		<div className="wheel__slice-prize">
            <div className="wheel__slice-contentPrize">
                <div className="wheel__slice-contentPrizeImage">
                    <ImageUpload extra={extra} campaign_id={currentCampaignId} file={prize.image} item="image" updateAction={autosave} />
                </div>
                <div className="wheel__slice-contentPrizeText">
                    {locked ?
                        <div>{prize?.text}</div>
                        :
                        <EditableInput type="text" extra={extra} withPencil item="text" startValue={prize?.text} updateAction={autosave} />
                    }
                    <div className="text--muted font--12">Stock: {compStock()}</div>
                </div>
                <div className="wheel__slice-contentPrizeActions">
                    <button className="btn btn-transparent btn-sm text--danger" onClick={() => deletePrize(prize, sliceIdx)} disabled={locked}>
                        <span className="material-icons font--18">
                            clear
                        </span>
                    </button>
                    <button className="btn btn-transparent btn-sm" onClick={() => setShowAdvanced(!showAdvanced)}>
                        {advancedOnModal &&
                            <span className="material-icons font--22">
                                edit
                            </span>
                        }
                        {!advancedOnModal && 
                            <span className="material-icons font--22">
                                {showAdvanced ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }
                            </span>
                        }
                        
                    </button>
                </div>
            </div>
            <div>
                {(inconsistentQuotaCount||overlappingQuotaWindows)&& 
                <div className="modal__body text--center">
                    <h4 className="text--warning">Warning!</h4>
                    <div>
                        {inconsistentQuotaCount && <div>The total prizes in quotas are not the same as the stock.</div>}
                        {overlappingQuotaWindows && <div>Some quotas are overlapping.</div>}
                    </div>
                </div>}
            </div>
            {advancedOnModal ?
                <>
                    {showAdvanced &&
                        <WheelOfPrizesPrizeOptionsModal prize={prize} locked={locked} update={autosave} extra={extra} setModal={setShowAdvanced} save={done} />
                    }
                </>
                :
                <>
                    {showAdvanced &&
                        <WheelOfPrizesPrizeAdvancedOptions prize={prize} locked={locked} update={autosave} extra={extra} />
                    }
                </>
            }
            
		</div>
	);
}

export default WheelOfPrizesPrizeOptions;
